import { render, staticRenderFns } from "./v-person-module.vue?vue&type=template&id=72cd84b0&scoped=true&"
import script from "./v-person-module.vue?vue&type=script&lang=ts&"
export * from "./v-person-module.vue?vue&type=script&lang=ts&"
import style0 from "./v-person-module.vue?vue&type=style&index=0&id=72cd84b0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72cd84b0",
  null
  
)

export default component.exports